import {DEFAULT_COL_WIDTH} from '../constants/defaultColWidth';
import type {EagColumn} from '../types/EagColumn';
import type {EagColumnState} from '../types/EagColumnState';

/**
 * Converts an EagColumn definition into its initial EagColumnState.
 * Used during mount to populate the store with default column positions and widths.
 */
export function columnToInitialState(column: EagColumn, index: number): EagColumnState {
  return {
    key: column.key,
    width: column.width ?? DEFAULT_COL_WIDTH,
    hidden: column.hidden ?? false,
    pinned: column.pinned ?? null,
    order: index,
    sort: column.sort ?? null,
    ...(column.sortIndex != null ? {sortIndex: column.sortIndex} : {}),
  };
}
